import { useContext, useState, useEffect } from "react";
import ButtonAction from "../../../elements/buttons/ButtonAction";
import modalContext from "../../../../dataManager/context/modalContext";
import productsContext from "../../../../dataManager/context/productsContext";
import Input from "../../../elements/form/Input";
import InputFile from "../../../elements/form/InputFile";
import Paragraph from "../../../elements/p/Paragraph";
import { percentageReduction } from "../../../../functions/functions";
import { updateProduct } from "../../../../api/products/productsApi";
import { toast } from "react-toastify";
import { checkFiels } from "../../../../functions/functions";
import { uploadImage } from "../../../../api/utils";

const EditProduct = () => {
  //context variable
  const { onClose, modalParams } = useContext(modalContext);
  const { getOneProduct } = useContext(productsContext);

  // get the current selected product
  const product = getOneProduct(modalParams.productId);

  // init the form state
  const initFormData = {
    name: product.getName,
    description: product.getDescription,
    prise: product.getPrise,
    oldPrise: product.getOldPrise,
    image: product.getImage,
    caracteristics: product.getCaracteristics,
  };

  //form state variables
  const [formData, setFormData] = useState(initFormData);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  //firebase image variables
  const [imageUrl, setImageUrl] = useState("");
  const [progressLoadingImage, setProgressLoadingImage] = useState(0);
  const [isLoadingImage, setIsLoadingImage] = useState(false);

  //somes handlers
  const handleChange = (e, inputTarget) => {
    setError("");

    switch (inputTarget) {
      case "name":
        return setFormData({ ...formData, name: e.target.value });
      case "description":
        return setFormData({ ...formData, description: e.target.value });
      case "prise":
        return setFormData({ ...formData, prise: e.target.value });
      case "oldPrise":
        return setFormData({ ...formData, oldPrise: e.target.value });
      case "image":
        return setFormData({ ...formData, image: e.target.files[0] });
      case "caracteristics":
        return setFormData({ ...formData, caracteristics: e.target.value });
      default:
        return;
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    //check if all fields are filled
    const allFieldsFilled = checkFiels(formData);
    if (!allFieldsFilled) {
      return setError(
        "Remplissez tous les champs pour ajouter ce nouveau produit !"
      );
    }

    //start loading
    setLoading(true);

    //edit product without update the image
    if (formData.image === product.getImage) {
      return await editProduct(modalParams.productId, formData);
    }

    //update the image before edit the product
    uploadImage(
      "products",
      formData.image,
      setImageUrl,
      setProgressLoadingImage,
      setIsLoadingImage
    );
  };

  //useEffect section
  useEffect(() => {
    if (imageUrl) {
      editProduct(modalParams.productId, {
        ...formData,
        image: imageUrl,
      });
    }
  }, [imageUrl]);

  async function editProduct(idProduct, dataProduct) {
    //update the product
    const { data, error } = await updateProduct(idProduct, dataProduct);

    if (error) {
      setError(error);
      return setLoading(false);
    }

    if (!data) {
      setError("Une erreur est survenue");
      return setLoading(false);
    }

    setLoading(false);
    toast.success("l'article à été modifié avec succes !", {
      theme: "colored",
    });
    onClose();
  }

  //destructuring the formData
  const { name, description, prise, oldPrise, image, caracteristics } =
    formData;

  const persentageReductionBox = (
    <Paragraph size="small">
      Pourcentage de réductin{" "}
      {percentageReduction(Number(prise), Number(oldPrise))} %
    </Paragraph>
  );

  return (
    <div>
      <div className="flex flex-col space-y-2">
        <InputFile
          labelName="Image de cet article"
          name="image-category"
          onChange={(e) => handleChange(e, "image")}
        />
        <Input
          labelName="Nom article"
          type="text"
          name="name"
          placeholder="Ordinateur portable HP"
          value={name}
          onChange={(e) => handleChange(e, "name")}
        />
        <Input
          labelName="Caractéristiques"
          type="text"
          name="caracteristics"
          placeholder="cpu 2ghz, ram; 8 gb, disque dur: 800gb"
          value={caracteristics}
          onChange={(e) => handleChange(e, "caracteristics")}
        />
        <Input
          labelName="Prix"
          type="number"
          name="prise"
          placeholder="240 000"
          value={prise}
          onChange={(e) => handleChange(e, "prise")}
        />
        <Input
          labelName="Ancien prix"
          type="number"
          name="HoldPrise"
          placeholder="320 000"
          value={oldPrise}
          onChange={(e) => handleChange(e, "oldPrise")}
        />
        {prise && oldPrise && persentageReductionBox}
        <Input
          labelName="Descirption"
          type="text"
          name="description"
          placeholder="Ordinateur très résistant avec une bonne performance..."
          value={description}
          onChange={(e) => handleChange(e, "description")}
        />
      </div>
      <div className="mt-4 flex items-center">
        <ButtonAction
          onClick={(e) => handleUpdate(e)}
          loading={loading}
          size="small"
        >
          Modifier
        </ButtonAction>
        <ButtonAction size="small" type="secondary" onClick={onClose}>
          Anuler
        </ButtonAction>
      </div>
      <span className="font-nunito text-sm text-[#fc3838]">
        {error && error}
      </span>
    </div>
  );
};

export default EditProduct;
